export const COLORS = {
  darkModeBg: "#010219",
  white: "#FFFFFF",
  black: "#000000",
  grey: "#262636",
  lightGrey: "#D9D9D9",
  green: "#1D8C23",
  darkGrey: "#2D3748",
  lightBrown: "#DCDCDC",
  chartbg: "#242438",
  lightGreen: "#E4F3E5",

  //AAHERA COLOrs(LIGHT MODE)
  primary: "rgb(7,47,100)",
  primaryDark: "rgb(3, 23, 48)",
  primaryLight: "rgba(7, 47, 103, 0.8)",
  secondary: "#FC7067",
  bgGrey: "#F7F7F7",
  bgColor: "#EFE2FF",
  bgColorLight: "#F9F9F9",
  lightPink: "#FEE8E7",
};